import type { AnalyticsClient } from './types'
import { noopAnalytics } from './adapters/noop'
import { initPosthog, posthogClientAdapter } from './adapters/posthog-client'
import { readConsent } from './consent'

/**
 * Browser facade AND the single owner of PostHog startup.
 *
 * Returns the noop adapter unless a key is configured AND consent is 'granted'. When it
 * returns the real adapter it FIRST ensures posthog is inited (idempotent) — so any caller
 * (pageview tracker, web vitals, identify) can never capture before init, regardless of
 * React effect ordering. init only ever runs post-consent, so there is zero /ingest network
 * until the user accepts.
 */
export function getAnalytics(): AnalyticsClient {
  const key = process.env.NEXT_PUBLIC_POSTHOG_KEY
  if (!key || readConsent() !== 'granted') return noopAnalytics
  initPosthog(key)
  return posthogClientAdapter
}
